(function () {

    'use strict';

    angular.module('container.core')
        .constant('CONTAINER_API_URL', '/container/api/');
})();